// const ARS = {
//   shirtText: "ARS",
//   shirtColor: "#d71c34",
//   sleeveColor: "#fff",
//   shirtStyle: "checkered",
//   shirtStyleColor: "#d0162e",
// };

// const AVL = {
//   shirtText: "AVL",
//   shirtColor: "#872037",
//   sleeveColor: "#7ba3c5",
//   shirtStyle: "plain",
// };

// const BHA = {
//   shirtText: "BHA",
//   shirtColor: "#398ae7",
//   sleeveColor: "#398ae7",
//   shirtStyle: "thin-stripped",
//   shirtStyleColor: "#fff",
// };

// const BUR = {
//   shirtText: "BUR",
//   shirtColor: "#802f3f",
//   sleeveColor: "#7dacc1",
//   shirtStyle: "plain",
// };

// const CHE = {
//   shirtText: "CHE",
//   shirtColor: "#3956be",
//   sleeveColor: "#3956be",
//   shirtStyle: "plain",
// };

// const CRY = {
//   shirtText: "CRY",
//   shirtColor: "#2e58b0",
//   sleeveColor: "#2e58b0",
//   shirtStyle: "stripped",
//   shirtStyleColor: "#e72743",
// };

// const EVE = {
//   shirtText: "EVE",
//   shirtColor: "#2456bc",
//   sleeveColor: "#2456bc",
//   shirtStyle: "plain",
// };

// const FUL = {
//   shirtText: "FUL",
//   shirtColor: "#fff",
//   sleeveColor: "#363433",
//   shirtStyle: "plain",
//   textColor: "#222",
// };
// const LEI = {
//   shirtText: "LEI",
//   shirtColor: "#3054aa",
//   sleeveColor: "#3054aa",
//   shirtStyle: "plain",
// };

// const LEE = {
//   shirtText: "LEE",
//   shirtColor: "#fff",
//   sleeveColor: "#fff",
//   shirtStyle: "plain",
//   textColor: "#5f6aa9",
// };

// const LIV = {
//   shirtText: "LIV",
//   shirtColor: "#eb2948",
//   sleeveColor: "#eb2948",
//   shirtStyle: "plain",
// };

// const MCI = {
//   shirtText: "MCI",
//   shirtColor: "#80ccf0",
//   sleeveColor: "#80ccf0",
//   shirtStyle: "plain",
//   textColor: "#05335a",
// };

// const MUN = {
//   shirtText: "MUN",
//   shirtColor: "#d42849",
//   sleeveColor: "#d42849",
//   shirtStyle: "plain",
//   textColor: "#e49643",
// };
// const NEW = {
//   shirtText: "NEW",
//   shirtColor: "#111",
//   sleeveColor: "#111",
//   shirtStyle: "stripped",
//   textColor: "#66cbff",
//   shirtStyleColor: "#e9e9e9",
// };
// const SHU = {
//   shirtText: "SHU",
//   shirtColor: "#fff",
//   sleeveColor: "#fff",
//   shirtStyle: "thick-stripped",
//   textColor: "#111",
//   shirtStyleColor: "#cb3032",
// };

// const SOU = {
//   shirtText: "SOU",
//   shirtColor: "#cd1f33",
//   sleeveColor: "#cd1f33",
//   shirtStyle: "single-band",
//   textColor: "#111",
//   shirtStyleColor: "#fff6fc",
//   bandDirection: "diagonal-left",
// };

// const TOT = {
//   shirtText: "TOT",
//   shirtColor: "#fff",
//   sleeveColor: "#2b2839",
//   shirtStyle: "plain",
//   textColor: "#bf1b39",
// };

// const WBA = {
//   shirtText: "WBA",
//   shirtColor: "#223865",
//   sleeveColor: "#223865",
//   shirtStyle: "stripped",
//   shirtStyleColor: "#fff",
// };

// const WHU = {
//   shirtText: "WHU",
//   shirtColor: "#8b1e37",
//   sleeveColor: "#a4badb",
//   shirtStyle: "plain"
// };

// const WOL = {
//   shirtText: "WOL",
//   shirtColor: "#e79d22",
//   sleeveColor: "#2b2724",
//   shirtStyle: "plain",
//   textColor: "#2b2724",
// };
// const jerseyDesigns = {
//   ARS,
//   AVL,
//   BHA,
//   BUR,
//   CHE,
//   CRY,
//   EVE,
//   FUL,
//   LEI,
//   LIV,
//   LEE,
//   MCI,
//   MUN,
//   NEW,
//   SHU,
//   SOU,
//   TOT,
//   WBA,
//   WHU,
//   WOL,
// };

// export default jerseyDesigns;

const jerseyDesigns = {
  ARS: {
    shirtText: "Emirates",
    shirtColor: "#f00000",
    sleeveColor: "#fff",
    shirtStyle: "checkered",
    shirtStyleColor: "#dc0001",
    textColor: "#fff",
  },
  AVL: {
    shirtText: "CAZOO",
    shirtColor: "#670e36",
    sleeveColor: "#94bee5",
    shirtStyle: "plain",
    textColor: "#fff",
  },
  BHA: {
    shirtText: "AMERICAN",
    shirtColor: "#398ae7",
    sleeveColor: "#398ae7",
    shirtStyle: "striped-thin",
    shirtStyleColor: "#fff",
    textColor: "#fff",
  },
  BUR: {
    shirtText: " #|# ",
    shirtColor: "#81204c",
    sleeveColor: "#8bd3f5",
    textColor: "#fff",
  },
  CHE: {
    shirtText: "3",
    shirtColor: "#001489",
    sleeveColor: "#001489",
    shirtStyle: "plain",
    textColor: "#fff",
  },
  CRY: {
    shirtText: "W88",
    shirtColor: "#014a97",
    sleeveColor: "#014a97",
    shirtStyle: "striped",
    shirtStyleColor: "#ff362b",
    textColor: "#fff",
  },
  EVE: {
    shirtText: "CAZOO",
    shirtColor: "#00318e",
    sleeveColor: "#00318e",
    shirtStyle: "plain",
    textColor: "#fff",
  },
  FUL: {
    shirtText: "BETVICTOR",
    shirtColor: "#fff",
    sleeveColor: "#333",
    shirtStyle: "plain",
    textColor: "#222",
  },
  LEE: {
    shirtText: "SBOTOP",
    shirtColor: "#ffffff",
    sleeveColor: "#ffffff",
    shirtStyle: "plain",
    textColor: "#1d4189",
  },
  LEI: {
    shirtText: "THAILAND",
    shirtColor: "#003090",
    sleeveColor: "#003090",
    shirtStyle: "plain",
    textColor: "#fefefe",
  },
  LIV: {
    shirtText: "Standard &",
    shirtColor: "#e31b23",
    sleeveColor: "#e31b23",
    shirtStyle: "plain",
    textColor: "#fff",
  },
  MCI: {
    shirtText: "ETIHAD",
    shirtColor: "#98c5e9",
    sleeveColor: "#98c5e9",
    shirtStyle: "plain",
    textColor: "#00285e",
  },
  MUN: {
    shirtText: "Chevrolet",
    shirtColor: "#c70101",
    sleeveColor: "#c70101",
    shirtStyle: "plain",
    textColor: "#fed500",
  },
  NEW: {
    shirtText: "FUN88",
    shirtColor: "#fff",
    sleeveColor: "#333",
    shirtStyle: "striped",
    shirtStyleColor: "#111",
    textColor: "#00bcf6",
  },
  SHU: {
    shirtText: "## USG",
    shirtColor: "#fff",
    sleeveColor: "#fff",
    shirtStyle: "striped-thick",
    shirtStyleColor: "#e30613",
    textColor: "#111",
  },
  SOU: {
    shirtText: "Sportsbet",
    shirtColor: "#ff0028",
    sleeveColor: "#ff0028",
    shirtStyle: "single-band",
    shirtStyleColor: "#fff",
    textColor: "#111",
    shirtStyleDirection: "diagonal-left",
  },
  TOT: {
    shirtText: "AIA",
    shirtColor: "#fff",
    sleeveColor: "#0a225c",
    shirtStyle: "plain",
    textColor: "#d31145",
  },
  WBA: {
    shirtText: "ideal",
    shirtColor: "#fff",
    sleeveColor: "#002f68",
    shirtStyle: "striped",
    shirtStyleColor: "#002f68",
    textColor: "#fff",
    textBackgroundColor:"#002f68",
  },
  WHU: {
    shirtText: "betWay",
    shirtColor: "#7d2b3a",
    sleeveColor: "#59b3e4",
    shirtStyle: "plain",
    textColor: "#fff",
  },
  WOL: {
    shirtText: "FiT|#",
    shirtColor: "#fdb913",
    sleeveColor: "#333",
    shirtStyle: "plain",
    textColor: "#222",
  },
};

export default jerseyDesigns;